export const END_MEETING = 'events/END_MEETING';

/**
 * @return {{type: string, payload: *}}
 */
export const endMeeting = () => ({
  type: END_MEETING,
});
